import type { MeProfile } from '@/api/types';

export type SearchVisibility = 'private' | 'workspace';

export function normalizeSearchVisibility(
  value: SearchVisibility | string | null | undefined,
): SearchVisibility {
  const raw = (value ?? 'private').toLowerCase();
  if (raw === 'workspace' || raw === 'organization' || raw === 'shared') return 'workspace';
  return 'private';
}

export function defaultSearchVisibility(me: MeProfile | null | undefined): SearchVisibility {
  if (me?.permissions.canChangeSearchVisibilityAny) return 'workspace';
  return 'private';
}

export function canEditSearchVisibility(
  me: MeProfile | null | undefined,
  search: { user_id?: string | null; creator_user_id?: string | null },
): boolean {
  if (!me || me.permissions.readOnly) return false;
  if (me.permissions.canChangeSearchVisibilityAny) return true;
  if (!me.permissions.canChangeSearchVisibilityOwn) return false;
  const ownerId = search.creator_user_id ?? search.user_id;
  return Boolean(ownerId && me.id && ownerId === me.id);
}

export function showWorkspaceVisibilityOption(me: MeProfile | null | undefined): boolean {
  return Boolean(
    me?.permissions.canChangeSearchVisibilityOwn || me?.permissions.canChangeSearchVisibilityAny,
  );
}
